import styled from 'styled-components';

import { media } from 'utils/detection';
import withParallax from 'utils/parallax';

export const Role = styled.h1`
  color: ${props => props.theme.textSemiDark};
  font-size: 1.5rem;
  text-align: left;
  position: relative;

  font-weight: ${({ boldOut }) => (boldOut ? 900 : 400)};
  line-height: 23.33px;
  padding: 0;
  margin: 0;
  color: #112f47;

  ::after {
    content: ${({ afterContent }) => `"${afterContent}"`};
    display: inline-block;
    font-size: .7rem;
    position: absolute;
    text-transform:uppercase;
    top: -1.8rem;
    opacity:0.7;
    left: 0;
    letter-spacing:0.1rem;

    ${media.medium`
    top: -4.7rem;
    `}
  }

  ${media.medium`
    font-size: 3.8vw;
    line-height: 5vw;
  `}

  ${media.large`
    font-size: 3.8vw;
    line-height: 5vw;
  `}
`;

export const RoleContainer = styled.div`
  flex: 0.4;
  font-family: 'Galano Classic';
`;

export const Position = styled.h2`
  font-weight: 100;
  opacity: 0.7;
  text-align: left;
  line-height: 3rem;
  padding: 0;
  margin: 0;
  font-size: 0.8rem;

  ${media.medium`
    font-size: 1.3vw;
  `}

  ${media.large`
    font-size: 1.3vw;
  `}
`;
export const Container = styled.div`
  font-size: 16px;
  letter-spacing: 0.001rem;
  line-height: 2rem;
  text-align: justify;
  flex: 0.4;
  font-family: 'Galano Classic';
  color: #112f47;
  width: 80%;

  p {
    padding: 0;
    margin: 0;
  }
`;


export const Image = styled.img`
width: 100%;
`;


export const Wrapper = styled.div`
  position: relative;
  color: #112f47;
  z-index: 1;
  height: 100%;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;
  display: flex;
  flex-direction: column;

  ${media.medium`
    font-size: 1.3vw;
    flex-direction: row;
    gap: 5rem;
  `}
`;
